import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link } from "react-router-dom";
import { loginSchema } from "../../models/schema/auth";
import LoginForm from "../../components/auth/loginForm";
import { LoginRequest } from "../../models/types/auth";
import authSvc from "../../services/api/auth";
import { setCookiesUser, removeCookies } from "../../utils/configuration";
import { notify } from "../../common/notificationService";
// --- icon ---
import { LoaderCircle } from "lucide-react";
import DialogComponent from "../../components/dialog";
import Login2FA from "./Login2FA";
export default function LoginPage(): JSX.Element {

    const [isLoading, setIsLoading] = useState(false);
    const [isStatus2FA, setIsStatus2FA] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        getValues
    } = useForm({
        mode: "onBlur",
        resolver: yupResolver(loginSchema),
    });

    const onSubmit = async (data: LoginRequest) => {
        if (!data) return;
        setIsLoading(true);
        try {
            const res = await authSvc.login({ ...data, returnUrl: '/' });
            if (res && res.content) {
                if (!res.content.isUse2Fa) {
                    setCookiesUser(res.content);
                    removeCookies("isShowDialog");
                    removeCookies("isLockScreen");
                    window.location.replace(res.content.returnUrl || '/');
                } else if (res.content.isUse2Fa) {
                    setIsStatus2FA(true);
                }
            } else {
                notify('Đăng nhập thất bại', 'Vui lòng kiểm tra lại thông tin đăng nhập', 'danger');
            }
        }
        catch (e: any) {
            notify('Đăng nhập thất bại', 'Vui lòng kiểm tra lại thông tin đăng nhập', 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
                <div className="w-full max-w-md p-6 bg-white rounded-lg shadow">
                    <h2 className="text-3xl font-bold text-center">
                        Login
                    </h2>

                    <form
                        className="mt-8 space-y-6"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <LoginForm
                            register={register}
                            errors={errors}
                            control={control}
                        />
                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                disabled={isLoading}
                            >
                                {isLoading ? <LoaderCircle className="animate-spin mr-2" /> : "Login"}
                            </button>
                        </div>
                        <div className="text-center">
                            Don't have an account?
                            <Link
                                to=""
                                className="text-sm font-medium text-indigo-600 hover:text-indigo-500 ml-2"
                            >
                                Register
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
            {isStatus2FA && (
                <DialogComponent isOpen={isStatus2FA} onClose={() => setIsStatus2FA(false)} title="Nhập mã xác nhận">
                    <Login2FA dataFormLogin={getValues()} />
                </DialogComponent>
            )}
        </>
    );
}
